import { useMemo } from 'react';
import { usePromise } from '../../hooks/usePromise';
import { useFetch } from '../../services/NetworkService';
import { API3Endpoint } from './Api3Endpoint';
import { api3Call } from './client';

export const useApi3 = <Return>(endpoint: API3Endpoint<Return>) => {
  const fetch = useFetch();

  const promise = useMemo(() => (process.browser ? api3Call(fetch, endpoint) : null), [
    endpoint,
    fetch,
  ]);

  return usePromise(promise);
};
